import React, {useEffect, useState} from "react";
import CustomInput from "../../common/components/CustomInput";
import CustomSelect from "../../common/components/CustomSelect";
import CustomButton from "../../common/components/CustomButton";
import {eventConstants} from "../../constants";
import Utility, {dispatchAction} from "../../utility";
import categoryService from "../../services/category";
import bannerService from "../../services/banner";
import {connect} from "react-redux";
import Dropzone from "react-dropzone";
import Utils from "../../utility";
import {getSignedURL, uploadFileToS3} from "../../managers/awsService";
import {ThumbnailImg} from "../category/advertisersComponent";
import {MainContainer} from "../plans/styles";
import {Heading, InputColumn, InputRow, UploadButton} from "../../common/atoms/styles";
import {FormField} from "../../common/atoms/formElements";


const AddBannerComponent = (props) => {
    const {isToUpdate, data} = props

    const [parentCategory, setParentCategory] = useState([]);

    const [name, setName] = useState(data?.name || "");
    const [selectedParent, setParent] = useState("");
    const [media, setMedia] = useState(data?.media || undefined);
    const getCategoryList = async () => {
        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            categoryService.getCategoryList(),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) return Utility.apiFailureToast("Unable to fetch category");
        const parents = res.filter((data) => data.parentId == 0);
        setParentCategory(parents);
        setParent(parents[0]);
    }

    useEffect(() => {
        getCategoryList().then(() => 'fetched')
    }, []);

    const onFileDrop = async (files) => {
        if (!files || files.length < 1) {
            Utils.apiFailureToast("Unable to find Media");
            return;
        }
        let file = files[0];
        let fileDetail = Utils.getFileName(file.name);
        let companyLogo = Utils.getNewFileName("category", fileDetail.extension);
        let resFromS3 = await uploadFileToS3(file, companyLogo, file.type).catch(
            (err) => {
                Utils.apiFailureToast("Unable to upload media");
                return false;
            },
        );
        let logoURL = await getSignedURL(companyLogo);
        if (!resFromS3 || !logoURL) {
            Utils.apiFailureToast("Unable to upload media");
            return false;
        }
        setMedia(companyLogo);
    };

    const onSubmitBanner = async () => {
        if (!media) {
            return Utility.apiFailureToast("Image Required!");
        }
        const reqData = {name, media};
        reqData.categoryId = selectedParent._id;
        reqData.categoryName = selectedParent.name;
        if (isToUpdate)
            reqData._id = data._id;
        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            isToUpdate ? bannerService.updateBanner(reqData) : bannerService.addBanner(reqData),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) return Utility.apiFailureToast("Unable to add banner");
        if (isToUpdate)
            props.closeDialog()

    };
    const acceptanceString = ".jpg, .jpeg, .png, .svg";
    return (
        <MainContainer>
            <Heading>{`${isToUpdate ? 'Update' : 'Add'} Banner`}</Heading>
            <InputRow>
                <InputColumn>
                    <FormField isMandatory={true} label='Banner Name'>
                        <CustomInput
                            placeholder="Enter here"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Select Category'>
                        <CustomSelect
                            options={parentCategory}
                            onSelect={(e) => {
                                let find = parentCategory.find((data) => data._id === e.target.value);
                                setParent(find)
                            }}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Banner Image'>
                        <Dropzone
                            multiple={false}
                            accept={acceptanceString}
                            onDrop={(files) => {
                                onFileDrop(files).then(() => 'file dropped')
                            }}
                            noClick={true}
                            onFileDialogCancel={() => setMedia(undefined)}
                        >
                            {({getRootProps, getInputProps, open}) => (
                                <div {...getRootProps()} className="outline-none">
                                    <input {...getInputProps()} />
                                    <UploadButton onClick={() => open()}>
                                        {media ? 'Change Logo' : 'Upload Logo'}
                                    </UploadButton>
                                </div>
                            )}
                        </Dropzone>
                    </FormField>
                    {media &&
                        <ThumbnailImg src={getSignedURL(media)}/>
                    }
                    <CustomButton text={isToUpdate ? "Update" : "Save"} onClick={onSubmitBanner}/>
                </InputColumn>
            </InputRow>
        </MainContainer>
    );
};

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(
    AddBannerComponent,
);
